import React from "react";
import { DealsContext, FLYOUT_SCREENS, REDEMPTION_TYPES } from "@Src/routes/deals/Deals.context";
import { ScreenLocationDeals, ScreenShowGenerateCoupon } from "./index";
import { useSelector } from "react-redux";
import { selectors } from "@ReduxStore/reducers";
import classNames from "classnames";

export default function ScreensIndex() {
  const context = React.useContext(DealsContext);
  const screen = context.currentFlyoutScreen;
  const userIsAuthenticated = useSelector(selectors.hasAuthenticatedUser);
  const program = useSelector(selectors.getProgram);
  const language = useSelector(selectors.getLanguageSelector);

  function renderScreen() {
    switch (screen) {
      case FLYOUT_SCREENS.LOCATION_DEALS:
        return <ScreenLocationDeals />;
      case FLYOUT_SCREENS.SHOW_PRINT_PREVIEW:
        return (
          <ScreenShowGenerateCoupon
            which={REDEMPTION_TYPES.PRINT}
            program={program}
            language={language}
          />
        );
      case FLYOUT_SCREENS.SHOW_COUPON:
        return (
          <ScreenShowGenerateCoupon
            which={REDEMPTION_TYPES.SHOW}
            program={program}
            language={language}
          />
        );
      case FLYOUT_SCREENS.SHOW_LINK:
        return (
          <ScreenShowGenerateCoupon
            which={REDEMPTION_TYPES.ONLINE}
            program={program}
            language={language}
          />
        );
      case FLYOUT_SCREENS.SHOW_PHONE:
        return (
          <ScreenShowGenerateCoupon
            which={REDEMPTION_TYPES.CALL}
            program={program}
            language={language}
          />
        );
      default:
        return <ScreenLocationDeals />;
    }
  }
  return (
    <div
      className={classNames("ScreensIndex", {
        "isLoggedOut": !userIsAuthenticated,
        "offer-not-coupon":
          screen === FLYOUT_SCREENS.SHOW_LINK || screen === FLYOUT_SCREENS.SHOW_PHONE,
      })}
    >
      {renderScreen()}
    </div>
  );
}
